'use client';
import React from 'react';
import {
    listPath,
    listTitle,
    listTarget,
    descriptionBlock,
    listProcess,
    implementationBlock,
    implementationBlock2,
    textBlock,
    imageBlock,
    textBlock2,
    quoteBlock,
    textBlock3,
    resultBlock,
    resultBlock2,
    developmentBlock,
    listTeam,
    iconsBlock,
    nextProjectFrt,
} from './contstants';

import QuoteBlock from '../reusable-components/layouts-components__frt-service/quote-block';
import './style.sass';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import BlocksIcons from '../reusable-components/layouts-components__frt-service/blocks-icons';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TitleCase from '../../case-components/title-case';
import TargetCase from '../../case-components/target-case';
import CaseBlock from '../../case-components/case-block';
import ProcessCase from '../../case-components/process-case';
import DiagrammCase from '../../case-components/diagramm-case';
import TeamCase from '../../case-components/team-case';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import BannerFillWidth from '../../case-components/banner-full-width';
const FrtService = () => {
    return (
        <div className="frt-service">
            <TitleCase
                img="/images/pic/frtService/banner.jpg"
                listPath={listPath}
                listTitle={listTitle}
                caseName="frt-service__first-screen"
            />
            <TargetCase listTarget={listTarget} />
            <CaseBlock
                params={descriptionBlock}
                caseName={'frt-service__desc'}
                isBorder={false}
                isTop={true}
            />
            <div className="frt-service__tasks">
                <ProcessCase listProcess={listProcess} />
            </div>
            <CaseBlock params={implementationBlock} caseName={'frt-service__implementation mb-0'} />
            <CaseBlock params={implementationBlock2} caseName={'frt-service__implementation'} />
            <BannerFillWidth
                banner="/images/pic/frtService/bannerImp.jpg"
                alt={'Фрт'}
                customClass={'frt-service__banner'}
            />
            <CaseBlock params={textBlock} caseName={'frt-service__block'} />
            <DiagrammCase params={imageBlock} caseName={'frt-service__diagramm'} />
            <CaseBlock params={textBlock2} caseName={'mt-60 mb-40'} />
            <QuoteBlock params={quoteBlock} caseName={'mb-40'} />
            <CaseBlock params={textBlock3} />
            <CaseBlock params={resultBlock} caseName={'frt-service__results'} />
            <CaseBlock params={resultBlock2} caseName={'mb-24'} />
            <BlocksIcons list={iconsBlock} caseName={'frt-service__icons-block'} />
            <CaseBlock params={developmentBlock} caseName={'frt-service__development'} />
            <TeamCase listTeam={listTeam} />
            <ScrollAnimation>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>
            <NextProject NextProject={nextProjectFrt} />
        </div>
    );
};
export default FrtService;
